module.exports = __webpack_public_path__ + "img/earth.2df8a7b2.png";